import mapFunction from './mapResources';

export default mapFunction('cars', {
    isFetching: false,
    items: [] 
});